import {
  IPendingRegistrationApi,
  PendingRegistrationResponse,
  CompleteRegistrationRequest,
} from '../api/PendingRegistrationApi'
import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IPendingRegistrationService extends IInit {
  getPendingRegistration(token: string): Observable<PendingRegistrationResponse | undefined>
  completeRegistration(request: CompleteRegistrationRequest): Observable<boolean>
}

export class PendingRegistrationService implements IPendingRegistrationService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IPendingRegistrationApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IPendingRegistrationApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getPendingRegistration(token: string): Observable<PendingRegistrationResponse | undefined> {
    return this._api.getByToken(token)
  }

  completeRegistration(request: CompleteRegistrationRequest): Observable<boolean> {
    return this._api.completeRegistration(request)
  }
}
